<div *ngIf="isReactive" [formGroup]="parentForm" class="radio-btn-group">
  <label class="radio-label">{{label}} <span *ngIf="isRequired" class="error-msg"> *</span></label>
  <mat-radio-group [formControlName]="formFieldName"
                   labelPosition="{{labelPosition}}" (change)="changeEvent()" class="{{className}}" >
    <mat-radio-button [disableRipple]="true"  *ngFor="let item of options" value="{{item.value}}" checked="{{item.isChecked ? true: false }}" disabled="{{item.isDisabled ? true: false}}">{{item.label}}</mat-radio-button>
  </mat-radio-group>
  <itb-divider [className]="'mat-divider'"></itb-divider>
</div>

<div *ngIf="!isReactive && !hasOptions" class="radio-btn-group">
  <label class="radio-label">{{label}} <span *ngIf="isRequired" class="error-msg"> *</span></label>
  <mat-radio-group labelPosition="{{labelPosition}}" (change)="changeEvent()" class="{{className}}" >
    <mat-radio-button [disableRipple]="true" value="{{value}}" checked="{{isChecked}}" disabled="{{isDisabled}}">{{value}}</mat-radio-button>
  </mat-radio-group>
  <itb-divider [className]="'mat-divider'"></itb-divider>
</div>

<div *ngIf="!isReactive && hasOptions" class="radio-btn-group">
  <label class="radio-label">{{label}} <span *ngIf="isRequired" class="error-msg"> *</span></label>
  <mat-radio-group labelPosition="{{labelPosition}}" class="{{className}}" >
    <mat-radio-button [disableRipple]="true" *ngFor="let item of options" value="{{item.value}}" checked="{{item.isChecked ? true: false }}" disabled="{{item.isDisabled ? true: false}}" (change)="simpleChangeEvent($event.value)">{{item.label}}</mat-radio-button>
  </mat-radio-group>
  <itb-divider [className]="'mat-divider'"></itb-divider>
</div>
